import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema4/GLB_T4_Moneda5.glb";
import { GUI } from "dat.gui";
import gsap from "gsap";

export class Moneda5 extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		// this.helpers()

	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Moneda = gltf.scene.getObjectByName("Moneda5", true);
		})
	}
	helpers() {
		const gui = new GUI();
		const escanerFolder = gui.addFolder("Moneda");
		escanerFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		escanerFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		escanerFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		escanerFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		escanerFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		escanerFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		escanerFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale x");
		escanerFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale y");
		escanerFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale z");
		escanerFolder.add(this, "visible").name("visible");
	}
	helpersChild() {
		// this.helpersMethod("CPU", this.Cpu);
	}
	helpersMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		const limit = 20;
		folferMostrador.add(position, "x", -limit, limit).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}
	onClose() {
		this.clearAnimation()
		this.Moneda.animation = gsap.to(this.Moneda.position, {
			x: -0.02,
			duration: 0.3,
			ease: "none",
		});
	}
	onFurther() {
		this.clearAnimation()
		this.Moneda.animation = gsap.to(this.Moneda.position, {
			x: 0,
			duration: 0.3,
			ease: "none",
		});
	}
	clearAnimation() {
		if (this.Moneda.animation) {
			this.Moneda.animation.kill();
		}
	}
}